import { FieldDef } from './fields'
import { LayoutDef } from './layouts'

export type ControlDef = LayoutDef | FieldDef

export * from './fields'
export * from './layouts'
export * from './rule'

export class FormDef {
  controls?: ControlDef[] = []
  options?: FormOptions = new FormOptions()
}

export class FormOptions {
  labelWidth?: string = '120px'
  labelPosition?: 'top' | 'left' | 'right' = 'right'
  disabled?: boolean = false
  size?: 'medium' | 'small' | 'mini' = 'medium'
}
